import Vue from 'vue'
import Router from 'vue-router'
import BasePage from '@/pages/bind/BasePage'
import BindPage from '@/pages/bind/BindPage'
import VerifyPage from '@/pages/bind/VerifyPage'
import SuccessPage from '@/pages/bind/SuccessPage'
import UpdatePage from '@/pages/bind/UpdatePage'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/bind/:type',
      component: BasePage,
      children: [
        {
          path: '',
          name: 'bind-new',
          component: BindPage
        },
        {
          path: 'verify',
          name: 'bind-verify',
          component: VerifyPage
        },
        {
          path: 'success',
          name: 'bind-success',
          component: SuccessPage
        },
        {
          path: 'update',
          name: 'bind-update',
          component: UpdatePage
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js